import type { MessaggioApi } from "./storia";

export interface RimedioAlBlocco {
  testo: string;
  /** Vero se ripartire senza i turni precedenti puo' far passare la domanda. */
  ricomincia: boolean;
}

/**
 * Cosa dire all'operatore quando il filtro di sicurezza ferma una domanda. Se la
 * richiesta portava una risposta del modello, il colpevole e' quasi sempre quella
 * e ripartire senza basta; altrimenti ripartire rimanderebbe la stessa richiesta.
 */
export function rimedioAlBlocco(inviati: MessaggioApi[], riferimento: string | null = null): RimedioAlBlocco {
  const coda = riferimento ? ` Riferimento per l'assistenza: ${riferimento}.` : "";
  if (inviati.some((m) => m.ruolo === "assistente")) {
    return {
      testo:
        "Il filtro di sicurezza del sito ha bloccato la richiesta per via di una risposta precedente. " +
        `Ricominciando la conversazione la domanda viene rifatta da capo.${coda}`,
      ricomincia: true,
    };
  }
  return {
    testo: `Il filtro di sicurezza del sito ha bloccato questa domanda: prova a riformularla.${coda}`,
    ricomincia: false,
  };
}
